import { animate, Component, EventEmitter, Input, Output, state, style, transition, trigger } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

@Component({
    selector: 'extended-search',
    templateUrl: 'extended-search.html',
    animations: [

        trigger('statSearch', [
            state('closed', style({
                height: '0px'
            })),
            state('open', style({
                minheight: '300px'
            })),
            transition('closed => open', animate('250ms ease-in')),
            transition('open => closed', animate('250ms ease-out'))
        ])
    ]
})
export class ExtendedSearch {

    @Input() category: any;
    @Output() onUpdateFilter: EventEmitter<any> = new EventEmitter<any>();
    @Output() startExtendedSearch: EventEmitter<any> = new EventEmitter<any>();

    statusSearch: any = 'closed';
    isExpanded: boolean = false;
    filter: any;
    previousFilter: any;
    datePickerConfig: object;

    constructor(public navCtrl: NavController,
                public navParams: NavParams) {
        this.resetFilter();
        this.datePickerConfig = {
            locale: 'de',
            format: 'DD.MM.YYYY',
            firstDayOfWeek: 'mo',
            showNearMonthDays: false
        };
    }

    /** Updates filter */
    updateExtendedSearch() {
        this.onUpdateFilter.emit(this.filter);
    }

    /** Toggles extended search area */
    toggleExtendedSearch() {
        this.isExpanded = !this.isExpanded;

        if (this.statusSearch === 'closed') {
            this.statusSearch = 'open';
            if (this.previousFilter) {
                this.filter = this.previousFilter;
            }
        } else {
            this.resetFilter({savePreviousFilter: true});
            this.statusSearch = 'closed';
        }

        this.onUpdateFilter.emit(this.filter);
    }

    /** Resets filter */
    resetFilter(config: { savePreviousFilter?: boolean, resetPreviousFilter?: boolean } = {
        savePreviousFilter: false,
        resetPreviousFilter: false
    }) {
        if (this.filter && config.savePreviousFilter) {
            this.savePreviousFilter();
        }

        let filter = {
            Document: {
                Aktenzeichen: '',
                Adresskennung: '',
                Datum: null,
                ADatum: null,
                pickerdate: null,
                bisDatum: null,
                vonDatum: null
            },
            Structure: {
                Aktenzeichen: ''
            },
            Folder: {
                Aktenzeichen: '',
                Adresskennung: ''
            },
            Address: {
                Vorname: '',
                Nachname: '',
                Strasse: '',
                StrOrt: ''
            },
            Meeting: {
                Datum: null,
                ADatum: null,
                bisDatum: null,
                vonDatum: null
            }
        };

        this.filter = filter;

        if (config.resetPreviousFilter) {
            this.previousFilter = filter;
        }
    }

    /** Saves previous filter */
    savePreviousFilter() {
        this.previousFilter = JSON.parse(JSON.stringify(this.filter));
    }

    /** Starts extended search */
    startSearch() {
        this.startExtendedSearch.emit(true);
    }

    /**
     * Resets filter
     * @param {string} cat
     * @param {string} field
     */
    resetDateTime(cat: string, field: string) {
        this.filter[cat][field] = null;
    }
}



// WEBPACK FOOTER //
// ./src/pages/search/extended-search/extended-search.ts